import React, { useState, useEffect } from 'react';
import '../Studentadmin/student-dashboard/Dashboard.css';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import { BASE_URL } from '../Config';
import axios from 'axios';

import { useVerification } from '../context/VerificationContext'; 

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function EmailMobileVerification() {
  // Replace local open states with context
  const {
  showMobile: showMobilePopup,
  setShowMobile: setShowMobilePopup,
  showEmail: showEmailPopup,
  setShowEmail: setShowEmailPopup,
} = useVerification();


  // Email states
  const [emailInput, setEmailInput] = useState('');
  const [emailOtp, setEmailOtp] = useState('');
  const [emailOtpSent, setEmailOtpSent] = useState(false);
  const [emailError, setEmailError] = useState({});
  const [loadingEmail, setLoadingEmail] = useState(false);

  // Mobile states
  const [mobileInput, setMobileInput] = useState('');
  const [mobileOtp, setMobileOtp] = useState('');
  const [mobileOtpSent, setMobileOtpSent] = useState(false);
  const [mobileError, setMobileError] = useState({});
  const [loadingMobile, setLoadingMobile] = useState(false);

  const userdatatoken = localStorage.getItem('userDatatoken');
  const token = localStorage.getItem('token_type');
  const tokendata = `Bearer ${userdatatoken?.replace(/"/g, '')}`;

  const [userdata, setUserdata] = useState(null);

  useEffect(() => {
    fetchProfileData();
  }, []);

  const fetchProfileData = async () => {
    try {
      const { data } = await axios.get(`${BASE_URL}profiles`, {
        headers: {
          Accept: 'application/json',
          Authorization: tokendata,
        },
      });

      setUserdata(data.data);

      // Use context setters instead of local ones
    //   setShowMobilePopup(data.data?.mobile_verified !== 'yes');
    //   setShowEmailPopup(data.data?.email_verified !== 'yes');
    } catch (error) {
      console.error('Error fetching profile:', error);
    }
  };

  // Email handlers
  const sendOtpForEmail = async (e) => {
    e.preventDefault();
    setLoadingEmail(true);
    setEmailError({});

    const formData = new FormData();
    formData.append('email', emailInput);

    try {
      const response = await axios.post(`${BASE_URL}send-otp-change-email`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Accept: 'application/json',
          Authorization: tokendata,
        },
      });

      if (response.data) {
        setEmailOtpSent(true);
      }
    } catch (error) {
      setEmailError(error.response?.data?.errors || {});
    } finally {
      setLoadingEmail(false);
    }
  };

  const verifyEmailOtp = async (e) => {
    e.preventDefault();
    setLoadingEmail(true);
    setEmailError({});

    const formData = new FormData();
    formData.append('email', emailInput);
    formData.append('otp', emailOtp);

    try {
      const response = await axios.post(`${BASE_URL}update-email`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Accept: 'application/json',
          Authorization: tokendata,
        },
      });

      if (response.data) {
        setShowEmailPopup(false);
        fetchProfileData();
      }
    } catch (error) {
      setEmailError(error.response?.data?.errors || {});
    } finally {
      setLoadingEmail(false);
    }
  };

  // Mobile handlers
  const sendOtpForMobile = async (e) => {
    e.preventDefault();
    setLoadingMobile(true);
    setMobileError({});

    const formData = new FormData();
    formData.append('mobile_number', mobileInput);

    try {
      const response = await axios.post(`${BASE_URL}send-otp-change-mobile-number`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Accept: 'application/json',
          Authorization: tokendata,
        },
      });

      if (response.data) {
        setMobileOtpSent(true);
        fetchProfileData();
      }
    } catch (error) {
      setMobileError(error.response?.data?.errors || {});
    } finally {
      setLoadingMobile(false);
    }
  };

  const verifyMobileOtp = async (e) => {
    e.preventDefault();
    setLoadingMobile(true);
    setMobileError({});

    const formData = new FormData();
    formData.append('mobile_number', mobileInput);
    formData.append('otp', mobileOtp);

    try {
      const response = await axios.post(`${BASE_URL}update-mobile-number`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Accept: 'application/json',
          Authorization: tokendata,
        },
      });

      if (response.data) {
        setShowMobilePopup(false);
        fetchProfileData();
      }
    } catch (error) {
      setMobileError(error.response?.data?.errors || {});
      console.log('Error verifying mobile:', error);
    } finally {
      setLoadingMobile(false);
    }
  };


  useEffect(() => {
   console.log("POPUP MOUNTED");
}, []);

  return (
    <div className="">
      {/* Email Verification Dialog */}
      <Dialog
        open={showEmailPopup}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setShowEmailPopup(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{
            fontWeight: 700,
            fontSize: '1.4rem',
            pb: 1,
            borderBottom: '1px solid #e0e0e0',
          }}
        >
          Verify Your Email Address
        </DialogTitle>

        <DialogContent sx={{ pt: 3 }}>
          <p style={{ marginBottom: '1.5rem', color: '#555', fontSize: '0.95rem' }}>
            You have not verified your email id. Please verify now
          </p>

          {emailError?.general && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {emailError.general}
            </Alert>
          )}

          <form onSubmit={emailOtpSent ? verifyEmailOtp : sendOtpForEmail}>
            <TextField
              fullWidth
              label="Email Address"
              type="email"
              value={emailInput}
              onChange={(e) => setEmailInput(e.target.value)}
              margin="normal"
              variant="outlined"
              required
              error={!!emailError?.email}
              helperText={emailError?.email?.[0]}
              disabled={emailOtpSent || loadingEmail}
              sx={{ mb: 2 }}
            />

            {emailOtpSent && (
              <TextField
                fullWidth
                label="Enter OTP"
                type="text"
                value={emailOtp}
                onChange={(e) => setEmailOtp(e.target.value)}
                margin="normal"
                variant="outlined"
                required
                disabled={loadingEmail}
              />
            )}

            <DialogActions sx={{ px: 0, pt: 3 }}>
              <Button
                onClick={() => setShowEmailPopup(false)}
                variant="outlined"
                disabled={loadingEmail}
                sx={{ mr: 1 }}
              >
                Cancel
              </Button>

              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={loadingEmail || !emailInput}
                startIcon={loadingEmail && <CircularProgress size={20} color="inherit" />}
              >
                {loadingEmail
                  ? 'Processing...'
                  : emailOtpSent
                  ? 'Verify OTP'
                  : 'Send OTP'}
              </Button>
            </DialogActions>
          </form>
        </DialogContent>
      </Dialog>

      {/* Mobile Verification Dialog */}
      <Dialog
        open={showMobilePopup}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setShowMobilePopup(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{
            fontWeight: 700,
            fontSize: '1.4rem',
            pb: 1,
            borderBottom: '1px solid #e0e0e0',
          }}
        >
          Verify Your Mobile Number
        </DialogTitle>

        <DialogContent sx={{ pt: 3 }}>
          <p style={{ marginBottom: '1.5rem', color: '#555', fontSize: '0.95rem' }}>
            You have not verified your mobile number. Please verify now
          </p>

          <form onSubmit={mobileOtpSent ? verifyMobileOtp : sendOtpForMobile}>
            <TextField
              fullWidth
              label="Mobile Number"
              type="text"
              value={mobileInput}
              onChange={(e) => setMobileInput(e.target.value)}
              margin="normal"
              variant="outlined"
              required
              error={!!mobileError?.mobile_number}
              helperText={mobileError?.mobile_number?.[0]}
              disabled={mobileOtpSent || loadingMobile}
              sx={{ mb: 2 }}
            />

            {mobileOtpSent && (
              <TextField
                fullWidth
                label="Enter OTP"
                type="text"
                value={mobileOtp}
                onChange={(e) => setMobileOtp(e.target.value)}
                margin="normal"
                variant="outlined"
                required
                disabled={loadingMobile}
              />
            )}

            <DialogActions sx={{ px: 0, pt: 3 }}>
              <Button
                onClick={() => setShowMobilePopup(false)}
                variant="outlined"
                disabled={loadingMobile}
                sx={{ mr: 1 }}
              >
                Cancel
              </Button>

              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={loadingMobile || !mobileInput}
                startIcon={loadingMobile && <CircularProgress size={20} color="inherit" />}
              >
                {loadingMobile
                  ? 'Processing...'
                  : mobileOtpSent
                  ? 'Verify OTP'
                  : 'Send OTP'}
              </Button>
            </DialogActions>
          </form>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default EmailMobileVerification;